module.exports = __webpack_public_path__ + "91b92fbdaed801d949c587b59c90a6f4.pdf";